export default __webpack_public_path__ + "static/media/(56).86b0e6c9.jpg";